const PbxxRecord = require('../../pbxx_record')

module.exports = class BrandTimeSeries extends PbxxRecord {
  static get class_name() {
    return 'BrandTimeSeries'
  }
}
